import {
  regionListConstants,
  downloadVersionFileConstants,
  globalReleasesConstants,
  checksumAlgorthmConstants,
  hm5GlobalReleasesConstants,
  saGlobalReleasesConstants,
  vs2jen2GlobalReleasesConstants,
  uaGlobalReleasesConstants,
  vs2ngaGlobalReleasesConstants,
  hmplusGlobalReleasesConstants,
} from "../_redux-constants";
import { commonService } from "../../_services";

function getRegionList() {
  function getRegionListLoad() {
    return { type: regionListConstants.REGION_LIST_LOADING };
  }
  function getRegionListSuccess(data) {
    return {
      type: regionListConstants.REGION_LIST_SUCCESS,
      data,
    };
  }
  function getRegionListFailure(error) {
    return {
      type: regionListConstants.REGION_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getRegionListLoad());
    return commonService.getRegionsList().then(
      (data) => {
        dispatch(getRegionListSuccess(data));
      },
      (error) => {
        dispatch(getRegionListFailure(error?.toString()));
      }
    );
  };
}

function downloadVersionFile(queryParams) {
  function downloadVersionFileLoad() {
    return { type: downloadVersionFileConstants.DWNLD_VERSION_FILE_LOADING };
  }
  function downloadVersionFileSuccess(data) {
    return {
      type: downloadVersionFileConstants.DWNLD_VERSION_FILE_SUCCESS,
      data,
    };
  }
  function downloadVersionFileFailure(error) {
    return {
      type: downloadVersionFileConstants.DWNLD_VERSION_FILE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(downloadVersionFileLoad());
    return commonService.downloadVersionFile(queryParams).then(
      (data) => {
        dispatch(downloadVersionFileSuccess(data));
      },
      (error) => {
        dispatch(downloadVersionFileFailure(error?.toString()));
      }
    );
  };
}

function globalReleasesList() {
  function GlobalReleasesListLoad() {
    return { type: globalReleasesConstants.GLOBAL_RELEASES_LIST_LOADING };
  }
  function GlobalReleasesListSuccess(data) {
    return {
      type: globalReleasesConstants.GLOBAL_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function GlobalReleasesListFailure(error) {
    return {
      type: globalReleasesConstants.GLOBAL_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(GlobalReleasesListLoad());
    commonService.getGlobalReleases().then(
      (data) => {
        dispatch(GlobalReleasesListSuccess(data));
      },
      (error) => {
        dispatch(GlobalReleasesListFailure(error?.toString()));
      }
    );
  };
}

function checksumAlgorithmList() {
  function CheckshumAlgorithmListLoad() {
    return { type: checksumAlgorthmConstants.CHECKSUM_ALGORITHM_LIST_LOADING };
  }
  function CheckshumAlgorithmListSuccess(data) {
    return {
      type: checksumAlgorthmConstants.CHECKSUM_ALGORITHM_LIST_SUCCESS,
      data,
    };
  }
  function CheckshumAlgorithmListFailure(error) {
    return {
      type: checksumAlgorthmConstants.CHECKSUM_ALGORITHM_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(CheckshumAlgorithmListLoad());
    commonService.getChecksumAlgmList().then(
      (data) => {
        dispatch(CheckshumAlgorithmListSuccess(data));
      },
      (error) => {
        dispatch(CheckshumAlgorithmListFailure(error?.toString()));
      }
    );
  };
}

function hm5GlobalReleasesList() {
  function HM5GlobalReleasesListLoad() {
    return {
      type: hm5GlobalReleasesConstants.HM5_GLOBAL_RELEASES_LIST_LOADING,
    };
  }
  function HM5GlobalReleasesListSuccess(data) {
    return {
      type: hm5GlobalReleasesConstants.HM5_GLOBAL_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function HM5GlobalReleasesListFailure(error) {
    return {
      type: hm5GlobalReleasesConstants.HM5_GLOBAL_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(HM5GlobalReleasesListLoad());
    commonService.getHM5GlobalReleases().then(
      (data) => {
        dispatch(HM5GlobalReleasesListSuccess(data));
      },
      (error) => {
        dispatch(HM5GlobalReleasesListFailure(error?.toString()));
      }
    );
  };
}
function hmplusGlobalReleasesList(device) {
  function HMPLUSGlobalReleasesListLoad() {
    return {
      type: hmplusGlobalReleasesConstants.HMPLUS_GLOBAL_RELEASES_LIST_LOADING,
    };
  }
  function HMPLUSGlobalReleasesListSuccess(data) {
    return {
      type: hmplusGlobalReleasesConstants.HMPLUS_GLOBAL_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function HMPLUSGlobalReleasesListFailure(error) {
    return {
      type: hmplusGlobalReleasesConstants.HMPLUS_GLOBAL_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(HMPLUSGlobalReleasesListLoad());
    commonService.getHMPLUSGlobalReleases(device).then(
      (data) => {
        dispatch(HMPLUSGlobalReleasesListSuccess(data));
      },
      (error) => {
        dispatch(HMPLUSGlobalReleasesListFailure(error?.toString()));
      }
    );
  };
}

function uaGlobalReleasesList() {
  function uaGlobalReleasesListLoad() {
    return {
      type: uaGlobalReleasesConstants.UA_GLOBAL_RELEASES_LIST_LOADING,
    };
  }
  function uaGlobalReleasesListSuccess(data) {
    return {
      type: uaGlobalReleasesConstants.UA_GLOBAL_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function uaGlobalReleasesListFailure(error) {
    return {
      type: uaGlobalReleasesConstants.UA_GLOBAL_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(uaGlobalReleasesListLoad());
    commonService.getUAGlobalReleases().then(
      (data) => {
        dispatch(uaGlobalReleasesListSuccess(data));
      },
      (error) => {
        dispatch(uaGlobalReleasesListFailure(error?.toString()));
      }
    );
  };
}

function saGlobalReleasesList() {
  function SaGlobalReleasesListLoad() {
    return {
      type: saGlobalReleasesConstants.SA_GLOBAL_RELEASES_LIST_LOADING,
    };
  }
  function SaGlobalReleasesListSuccess(data) {
    return {
      type: saGlobalReleasesConstants.SA_GLOBAL_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function SaGlobalReleasesListFailure(error) {
    return {
      type: saGlobalReleasesConstants.SA_GLOBAL_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(SaGlobalReleasesListLoad());
    commonService.getSaGlobalReleases().then(
      (data) => {
        dispatch(SaGlobalReleasesListSuccess(data));
      },
      (error) => {
        dispatch(SaGlobalReleasesListFailure(error?.toString()));
      }
    );
  };
}

function vs2jen2GlobalReleasesList() {
  function Vs2jen2GlobalReleasesListLoad() {
    return {
      type: vs2jen2GlobalReleasesConstants.VS2JEN2_GLOBAL_RELEASES_LIST_LOADING,
    };
  }
  function Vs2jen2GlobalReleasesListSuccess(data) {
    return {
      type: vs2jen2GlobalReleasesConstants.VS2JEN2_GLOBAL_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function Vs2jen2GlobalReleasesListFailure(error) {
    return {
      type: vs2jen2GlobalReleasesConstants.VS2JEN2_GLOBAL_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(Vs2jen2GlobalReleasesListLoad());
    commonService.getVs2jen2GlobalReleases().then(
      (data) => {
        dispatch(Vs2jen2GlobalReleasesListSuccess(data));
      },
      (error) => {
        dispatch(Vs2jen2GlobalReleasesListFailure(error?.toString()));
      }
    );
  };
}

function vs2ngaGlobalReleasesList() {
  function Vs2ngaGlobalReleasesListLoad() {
    return {
      type: vs2ngaGlobalReleasesConstants.VS2NGA_GLOBAL_RELEASES_LIST_LOADING,
    };
  }
  function Vs2ngaGlobalReleasesListSuccess(data) {
    return {
      type: vs2ngaGlobalReleasesConstants.VS2NGA_GLOBAL_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function Vs2ngaGlobalReleasesListFailure(error) {
    return {
      type: vs2ngaGlobalReleasesConstants.VS2NGA_GLOBAL_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(Vs2ngaGlobalReleasesListLoad());
    commonService.getVs2ngaGlobalReleases().then(
      (data) => {
        dispatch(Vs2ngaGlobalReleasesListSuccess(data));
      },
      (error) => {
        dispatch(Vs2ngaGlobalReleasesListFailure(error?.toString()));
      }
    );
  };
}

export const commonActions = {
  getRegionList,
  downloadVersionFile,
  globalReleasesList,
  checksumAlgorithmList,
  hm5GlobalReleasesList,
  saGlobalReleasesList,
  vs2jen2GlobalReleasesList,
  uaGlobalReleasesList,
  vs2ngaGlobalReleasesList,
  hmplusGlobalReleasesList,
};
